import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import axios from "axios";

const ActivateAccount = () => {
  const { token } = useParams();
  const [Stage, setStage] = useState("LOADING"); // LOADING||SUCCESS||FAIL

  useEffect(() => {
    toggleActivate();
  }, []);

  const toggleActivate = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") + "/api/activate?key=" + token,
    };
    axios(Req)
      .then((Res) => {
        setStage("SUCCESS");
      })
      .catch((Err) => {
        setStage("FAIL");
      });
  };

  return (
    <>
      {Stage === "LOADING" ? (
        <>
          <main className="activation-wrapper">
            <div className="loading-bar">
              <p className="loading-text">Verifying your email address...</p>
              <Stack spacing={2}>
                <LinearProgress
                  color="secondary"
                  sx={{
                    "& .MuiLinearProgress-bar": {
                      borderRadius: "8px",
                      backgroundColor: "#FB4764", // Change color of the loading bar
                    },
                    "& .MuiLinearProgress-track": {
                      backgroundColor: "black", // Change color of the track
                    },
                  }}
                />
              </Stack>
            </div>
          </main>
        </>
      ) : (
        <>
          {Stage === "SUCCESS" ? (
            <>
              <main className="activation-wrapper">
                <div className="loading-bar post-activation-text">
                  <p className="loading-text">
                    {
                      " Your email address has been successfully verified. you can now "
                    }
                    <Link to="/">Sign in here</Link>
                    {" to access your account."}
                  </p>{" "}
                </div>
              </main>
            </>
          ) : (
            <>
              <main className="activation-wrapper">
                <div className="loading-bar post-activation-text">
                  <p className="loading-text">
                    This email address does not exist or the verification link
                    has expired. <Link to="/Signup">Sign up here</Link>
                  </p>
                </div>
              </main>
            </>
          )}
        </>
      )}
    </>
  );
};

export default ActivateAccount;
